import { render, staticRenderFns } from "./ProcheForm.vue?vue&type=template&id=2a97fb21&"
import script from "./ProcheForm.vue?vue&type=script&lang=js&"
export * from "./ProcheForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports